let populationData = [
  {
    name: '北京',
    value: 21893095
  },
  {
    name: '天津',
    value: 13866009
  },
  {
    name: '河北',
    value: 74610235
  },
  {
    name: '山西',
    value: 34915616
  },
  {
    name: '内蒙古',
    value: 24049155
  },
  {
    name: '辽宁',
    value: 42591407
  },
  {
    name: '吉林',
    value: 24073453
  },
  {
    name: '黑龙江',
    value: 31850088
  },
  {
    name: '上海',
    value: 24870895
  },
  {
    name: '江苏',
    value: 84748016
  },
  {
    name: '浙江',
    value: 64567588
  },
  {
    name: '安徽',
    value: 61027171
  },
  {
    name: '福建',
    value: 41540086
  },
  {
    name: '江西',
    value: 45188635
  },
  {
    name: '山东',
    value: 101527453
  },
  {
    name: '河南',
    value: 99365519
  },
  {
    name: '湖北',
    value: 57752557
  },
  {
    name: '湖南',
    value: 66444864
  },
  {
    name: '广东',
    value: 126012510
  },
  {
    name: '广西',
    value: 50126804
  },
  {
    name: '海南',
    value: 10081232
  },
  {
    name: '重庆',
    value: 32054159
  },
  {
    name: '四川',
    value: 83674866
  },
  {
    name: '贵州',
    value: 38562148
  },
  {
    name: '云南',
    value: 47209277
  },
  {
    name: '西藏',
    value: 3648100
  },
  {
    name: '陕西',
    value: 39528999
  },
  {
    name: '甘肃',
    value: 25019831
  },
  {
    name: '青海',
    value: 5923957
  },
  {
    name: '宁夏',
    value: 7202654
  },
  {
    name: '新疆',
    value: 25852345
  },
  {
    name: '台湾',
    value: 23561236
  },
  {
    name: '香港',
    value: 7474200
  },
  {
    name: '澳门',
    value: 683218
  }
]
// 现役军人 2000000
export { populationData }
